export const conferenceStyles = `
    @keyframes float {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-20px); }
    }
    @keyframes shake {
        0%, 100% { transform: translate(0, 0); }
        25% { transform: translate(-5px, 5px); }
        50% { transform: translate(5px, -5px); }
        75% { transform: translate(-5px, -5px); }
    }
    .blink { animation: blink 1s infinite; }
    @keyframes blink { 50% { opacity: 0.5; } }

    @keyframes sound-wave {
        0%, 100% { height: 10%; }
        50% { height: 90%; }
    }

    @keyframes scan {
        0% { transform: translateY(0); opacity: 0; }
        30% { opacity: 1; }
        60% { transform: translateY(100vh); opacity: 0; }
        100% { transform: translateY(100vh); opacity: 0; }
    }

    .animate-scan {
        animation: scan 10s ease-in-out infinite;
    }

    .custom-scrollbar::-webkit-scrollbar { width: 4px; }
    .custom-scrollbar::-webkit-scrollbar-track { bg: rgba(0,0,0,0.2); }
    .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(59,130,246,0.3); border-radius: 2px; }

    @keyframes fade-in {
        from { opacity: 0; transform: scale(0.95); }
        to { opacity: 1; transform: scale(1); }
    }
    .animate-fade-in {
        animation: fade-in 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
    }

    @keyframes pulse-red {
        0%, 100% { border-color: rgba(239, 68, 68, 0.5); box-shadow: 0 0 20px rgba(239, 68, 68, 0.2); }
        50% { border-color: rgba(239, 68, 68, 1); box-shadow: 0 0 40px rgba(239, 68, 68, 0.5); }
    }
    .animate-pulse-red {
        animation: pulse-red 2s infinite;
    }

    .targeting-mode, .targeting-mode * {
        cursor: crosshair !important;
    }

    @keyframes ripple {
        0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
        100% {
            transform: translate(-50%, -50%) scale(4);
            opacity: 0;
        }
    }
    .animate-ripple {
        animation: ripple 0.6s ease-out forwards;
    }

    /* Jambes descendantes des titres en dégradé.
       Un texte peint via \`background-clip: text\` n'est visible que là où le
       fond de l'élément s'étend. Avec une interligne serrée, la boîte s'arrête
       à la ligne de base : le fond ne couvre pas les jambes des y, p, g, j, q,
       et les titres apparaissent coupés par le bas. Le symptôme est d'autant
       plus net que la police est grosse — donc sur les titres, précisément.

       Une seule règle plutôt qu'une rustine par gabarit : elle vaut pour les
       deux conférences et pour tout nouveau titre à venir. Les éléments qui
       portent déjà un \`pb-\` explicite sont exclus, pour ne pas leur retirer
       la marge, souvent plus grande, que leur gabarit avait choisie. */
    [class*="bg-clip-text"]:not([class*="pb-"]) {
        padding-bottom: 0.12em;
    }
`;
